/* Файл подключается несколькими секциями (main-product, product-recommendations,
   гриды коллекций) и может попасть на страницу дважды. Без guard повторное
   выполнение падает с SyntaxError: Identifier has already been declared. */
if (!customElements.get('quick-buy-card-preview')) {

class  QuickBuyCardPreview extends HTMLElement {
  constructor() {
      super();
      const labels = Array.from(this.querySelectorAll('label'));
      this.labels = this.querySelectorAll("label")
      labels.map(item => {
        item.addEventListener("click", (event) => {
          this.clickedLabel = item
          this.onVariantChange(event);
        })
      })
      // this.productVariantFieldset = this.querySelector('fieldset');
      // if (this.productVariantFieldset) {
      //     this.productVariantFieldset.addEventListener('change', this.onVariantChange);
      // }
  }

  disconnectedCallback() {
      if (this.labels) {
          this.labels.forEach(item => {
            item.removeEventListener("click", this.onVariantChange)
          })
      }
  }

  toFixed(number) {
      return Number(number / 100).toFixed(2)
  }

  onVariantChange = (evt) => {
      this.setVariantData();
      this.updateOptions();
      this.updateMasterId();

      // Instead of quick-adding to cart, go to the product page with the chosen size preselected.
      if (this.currentVariant) {
          const baseUrl = this.dataset.productUrl;
          if (baseUrl) {
              const separator = baseUrl.indexOf('?') === -1 ? '?' : '&';
              window.location.href = `${baseUrl}${separator}variant=${this.currentVariant.id}`;
          }
      }
  }

  updateOptions() {
    this.currentOption = this.clickedLabel.dataset.value
  }

  updateMasterId() {
      const variants = this.getVariantData();
      // The card overlay shows only the "Size" values, but a product may have extra
      // options (e.g. Size + length). Match by the clicked size value among a variant's
      // options and prefer an available one, so the click lands on a buyable variant of
      // that size; fall back to any variant with that size.
      this.currentVariant =
          variants.find((variant) => variant.available && variant.options.includes(this.currentOption))
          || variants.find((variant) => variant.options.includes(this.currentOption));
  }

  updateVariantInput() {
      const productForm = this.querySelector(".quick-buy-button");
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      this.setUnavailable(this.currentVariant.available)
  }

  getSelectedVariant() {
      return this.variantData.find((variant) => variant.id === this.currentVariant.id)
  }

  getPriceFromSellingPlan(variant) {
      return variant.selling_plan_allocations.reduce((acc, plan) => {
          if (!acc.price) {
              return {
                  price: plan.price,
                  compare_at_price: null
              }
          }
          if (plan.price < acc.price) {
              return {
                  price: plan.price,
                  compare_at_price: null
              }
          }
          return acc;
      }, { price: null, compare_at_price: null })
  }

  getLowestPrice(variant) {
      if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
          const planPrice = this.getPriceFromSellingPlan(variant);
          if (planPrice.price > 0) return planPrice;
      }

      return {
          compare_at_price: variant.compare_at_price,
          price: variant.price,
      };
  }

  isDifferenceVariantsPrice() {
      const variants = this.variantData
      if (variants && variants.length > 1) {
          const variantPrices = variants.map((variant) => variant.price)
          const uniqPrices = [...new Set(variantPrices)];
          return uniqPrices.length > 1;
      }

      return false;
  }

  removeErrorMessage() {
      const productForm = this.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
  }

  updatePrice(currentVariant, withFrom) {
      const updatedPrice = this.getLowestPrice(currentVariant);
      const priceContainer = this.querySelector(".product-preview-card__price");

      if (updatedPrice.compare_at_price) {
          priceContainer.innerHTML = `
              ${withFrom ? '<span>From&nbsp;</span>' : ""}
              <s>$${this.toFixed(updatedPrice.compare_at_price)}</s>
              <span> $${this.toFixed(updatedPrice.price)}</span>
          `
      } else {
          priceContainer.innerHTML = `
              ${withFrom ? '<span>From&nbsp;</span>': ""}
              <span>$${this.toFixed(updatedPrice.price)}</span>
          `
      }
  }

  getUpdatedImageSrcset(srcset, newSrc) {
      const regex = /(https:\/\/|\/\/)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(\?v=\d*)/gm
      return srcset.replace(regex, newSrc);
  }

  updateImageElement(imageSrc) {
      const imageObject = this.querySelector("media-gallery img");
      imageObject.src = `${imageSrc}`
      imageObject.srcset = this.getUpdatedImageSrcset(imageObject.srcset, imageSrc)
  }

  updateImages(currentVariant) {
      // thumbnail images
      // const variantImage = this.variantImages.find(({ id }) => id === currentVariant.id)
      // if (variantImage) {
      //     this.updateImageElement(variantImage.src);
      //     return
      // }
      if (currentVariant.featured_image) {
          this.updateImageElement(currentVariant.featured_image.src);
      }
  }

  renderProductInfo() {
      // const currentVariant = this.getSelectedVariant();
      // const isDifferentPrice = this.isDifferenceVariantsPrice();
      // this.updatePrice(currentVariant, isDifferentPrice);
      // this.updateImages(currentVariant);
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = this.querySelector("form");
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      if (!addButton) return;

      if (disable) {
          addButton.setAttribute('disabled', 'disabled');
      } else {
          addButton.removeAttribute('disabled');
      }

      if (!modifyClass) return;

  }

  setUnavailable(available) {
      const productForm = this.querySelector(".quick-buy-button");
      const button =  productForm.querySelector("button")
      if (!button) return;
      if(!available) {
      button.setAttribute('disabled', 'disabled');
      } else {
          button.removeAttribute('disabled');
      }
  }

  getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

  parseVariantData() {
      const { variants } = JSON.parse(this.querySelector('[type="application/json"]').textContent)
      return {
          variants,
      }
  }

  setVariantData() {
      this.variantData = this.variantData || this.parseVariantData().variants;
  }
}

customElements.define('quick-buy-card-preview', QuickBuyCardPreview);



class  ComplementaryQuickBuy extends HTMLElement {
    constructor() {
        super();
        // this.addEventListener('change', this.onVariantChange);
        const labels = Array.from(this.querySelectorAll('select'));
        this.labels = this.querySelectorAll("select")
        labels.map(item => {
          item.addEventListener("change", debounce((event) => {
            this.clickedLabel = item
            this.onVariantChange(event);
          }, 300))
        })
    }
  
    disconnectedCallback() {
        // this.removeEventListener('change', this.onVariantChange);
        if (this.labels) {
            this.labels.forEach(item => {
              item.removeEventListener("change", this.onVariantChange)
            })
        }
    }
  
    toFixed(number) {
        return Number(number / 100).toFixed(2)
    }
  
    onVariantChange = (evt) => {
        this.setVariantData();
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.removeErrorMessage();
  
        if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
        } else {
            this.updateVariantInput();
            this.renderProductInfo()
        }
        document.dispatchEvent(new CustomEvent("variantUpdate"));
    }
  
    updateOptions() {
        // const fieldsets = Array.from(this.querySelectorAll('fieldset'));
        // this.currentOption = fieldsets.map((fieldset) => {
        //   return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
        // });
        this.currentOption = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }
  
    updateMasterId() {
        this.currentVariant = this.getVariantData().find((variant) => {
            return !variant.options.map((option, index) => {
              return this.currentOption[index] === option;
            }).includes(false);
          });
    }
  
    updateVariantInput() {
        const productForm = this.querySelector(".quick-buy-button");
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        this.setUnavailable(this.currentVariant.available)
    }
  
    getSelectedVariant() {
        return this.variantData.find((variant) => variant.id === this.currentVariant.id)
    }
  
    getPriceFromSellingPlan(variant) {
        return variant.selling_plan_allocations.reduce((acc, plan) => {
            if (!acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            if (plan.price < acc.price) {
                return {
                    price: plan.price,
                    compare_at_price: null
                }
            }
            return acc;
        }, { price: null, compare_at_price: null })
    }
  
    getLowestPrice(variant) {
        if (variant.selling_plan_allocations && variant.selling_plan_allocations.length > 0) {
            const planPrice = this.getPriceFromSellingPlan(variant);
            if (planPrice.price > 0) return planPrice;
        }
  
        return {
            compare_at_price: variant.compare_at_price,
            price: variant.price,
        };
    }
  
    isDifferenceVariantsPrice() {
        const variants = this.variantData
        if (variants && variants.length > 1) {
            const variantPrices = variants.map((variant) => variant.price)
            const uniqPrices = [...new Set(variantPrices)];
            return uniqPrices.length > 1;
        }
  
        return false;
    }
  
    removeErrorMessage() {
        const productForm = this.querySelector('product-form');
        if (productForm) productForm.handleErrorMessage();
    }
  
    updatePrice(currentVariant, withFrom) {
        const updatedPrice = this.getLowestPrice(currentVariant);
        const priceContainer = this.querySelector(".product-preview-card__price");
  
        if (updatedPrice.compare_at_price) {
            priceContainer.innerHTML = `
                ${withFrom ? '<span>From&nbsp;</span>' : ""}
                <s>$${this.toFixed(updatedPrice.compare_at_price)}</s>
                <span> $${this.toFixed(updatedPrice.price)}</span>
            `
        } else {
            priceContainer.innerHTML = `
                ${withFrom ? '<span>From&nbsp;</span>': ""}
                <span>$${this.toFixed(updatedPrice.price)}</span>
            `
        }
    }
  
    getUpdatedImageSrcset(srcset, newSrc) {
        const regex = /(https:\/\/|\/\/)?([-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b)*(\/[\/\d\w\.-]*)*(\?v=\d*)/gm
        return srcset.replace(regex, newSrc);
    }
  
    updateImageElement(imageSrc) {
        const imageObject = this.querySelector("media-gallery img");
        imageObject.src = `${imageSrc}`
        imageObject.srcset = this.getUpdatedImageSrcset(imageObject.srcset, imageSrc)
    }
  
    updateImages(currentVariant) {
        // thumbnail images
        // const variantImage = this.variantImages.find(({ id }) => id === currentVariant.id)
        // if (variantImage) {
        //     this.updateImageElement(variantImage.src);
        //     return
        // }
        if (currentVariant.featured_image) {
            this.updateImageElement(currentVariant.featured_image.src);
        }
    }
  
    renderProductInfo() {
        // const currentVariant = this.getSelectedVariant();
        // const isDifferentPrice = this.isDifferenceVariantsPrice();
        // this.updatePrice(currentVariant, isDifferentPrice);
        // this.updateImages(currentVariant);
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  
    toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector("form");
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        if (!addButton) return;
  
        if (disable) {
            addButton.setAttribute('disabled', 'disabled');
        } else {
            addButton.removeAttribute('disabled');
        }
  
        if (!modifyClass) return;
  
    }
  
    setUnavailable(available) {
        const productForm = this.querySelector(".quick-buy-button");
        const button =  productForm.querySelector("button")
        if (!button) return;
        if(!available) {
        button.setAttribute('disabled', 'disabled');
        button.querySelector("p").textContent = "Sold out";
        } else {
            button.removeAttribute('disabled');
            button.querySelector("p").textContent = "Add to bag";
        }
    }
  
    getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
        return this.variantData;
      }
  
    parseVariantData() {
        const { variants } = JSON.parse(this.querySelector('[type="application/json"]').textContent)
        return {
            variants,
        }
    }
  
    setVariantData() {
        this.variantData = this.variantData || this.parseVariantData().variants;
    }
  }
  
  customElements.define('complementary-quick-buy', ComplementaryQuickBuy);

}